var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1126_22754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 12.7035V14.25H14V15.75H5V14.25H8.75V12.7035C7.30002 12.5207 5.96661 11.8149 5 10.7188C4.03339 9.62267 3.50002 8.21146 3.5 6.75V2.25H15.5V6.75C15.5 8.21146 14.9666 9.62267 14 10.7188C13.0334 11.8149 11.7 12.5207 10.25 12.7035ZM1.25 3.75H2.75V6.75H1.25V3.75ZM16.25 3.75H17.75V6.75H16.25V3.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1126_22754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyFill);
export default __webpack_public_path__ + "static/media/trophy-fill.905903241dfb39a9ee75ef815e39cae1.svg";
export { ForwardRef as ReactComponent };